module.exports = __webpack_public_path__ + "static/media/image-007n.e5ff9056.jpeg";